'use strict'

const colorPalette = [
  '#1ABC9C',
  '#16A085',
  '#2ECC71',
  '#27AE60',
  '#3498DB',
  '#2980B9',
  '#34495E',
  '#2C3E50',
  '#EA4C88',
  '#CA2C68',
  '#9B59B6',
  '#8E44AD',
  '#F1C40F',
  '#F39C12',
  '#E74C3C',
  '#C0392B',
  '#BDC3C7',
  '#7F8C8D',
  '#F3825B',
]

/**
 * @type {Array} sizes
 * @description The available sizes of the buttons
 */
export const stringConfig = {
  long: 45,
  width: 38,
  height: 38,
  str: '- ',
  bgColor: '#000',
  pictureFormat: 'png',
  fontWeight: '600',
  fontScale: 70,
  colorPalette,
  autoColor: true,
  textColor: '#fff',
}
